import React, { useEffect, useState } from "react";
import styles from "./Rating.module.scss";
import { ReactComponent as StarIcon } from "../../assets/images/star.svg";

const Star = ({ filled, label, onMouseEnter, onClick }) => (
  <div
    className={`${styles.Star}`}
    data-testid="RatingStar"
    onMouseEnter={onMouseEnter}
    onClick={onClick}
  >
    <div className={`d-flex flex-column align-items-center`}>
      <StarIcon className={`${filled ? `${styles.StarSelected}` : ""}`} />
      <span className={styles.Label}>{label}</span>
    </div>
  </div>
);

const Rating = ({ options, rating, onChange }) => {
  const [ratingIndex, setRatingIndex] = useState(-1);

  const onMouseEnter = (idx) => {
    setRatingIndex(idx);
  };
  const onMouseLeave = () => {
    setRatingIndex(options.indexOf(rating));
  };

  useEffect(() => {
    setRatingIndex(options.indexOf(rating));
  }, [options, rating]);

  return (
    <div className={`d-flex ${styles.Rating}`} onMouseLeave={onMouseLeave} data-testid="Rating">
      {options.map((label, idx) => (
        <Star
          key={`star-${label}`}
          filled={idx <= ratingIndex ? true : false}
          label={label}
          onMouseEnter={() => onMouseEnter(idx)}
          onClick={() => onChange && onChange(label)}
        />
      ))}
    </div>
  );
};

Rating.propTypes = {};

Rating.defaultProps = {};

export default Rating;
